module.exports = __webpack_public_path__ + "static/media/DetalleCurso2.6e98631b.svg";